import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import { login, logout } from '@/api/main/users'
import { Message } from 'element-ui'
import { sysOrgTree } from '@/api/main/system'
import { getToken, setToken, removeToken } from '@/utils/cookies'
import { setOrgTree, getOrgTree, setUserInfo, getUserInfo } from '@/utils/storage'
import router, { resetRouter } from '@/router'
import { PermissionModule } from './permission'
import { TagsViewModule } from './tags-view'
import store from '@/store'
import { Md5 } from 'ts-md5'
import { tabDtoList } from '@/router/staticRoute'
export interface TabItem {
  id: number
  tabCode: string
  tabName: string
}
export interface IUserState {
  token: string
  name: string
  avatar: string
  introduction: string
  roles: string[]
  accessList: string[]
  menuList: object[]
  tabDtoList: object[]
  email: string
  orgTree: object[],
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUserState {
  public token = getToken() || ''
  public name = ''
  public avatar = ''
  public introduction = ''
  public roles: string[] = []
  public accessList: string[] = []
  public menuList: object[] = []
  public tabDtoList: TabItem[] = []
  public orgTree = [JSON.parse(getOrgTree())]
  public email = ''
  public userInfo = JSON.parse(getUserInfo())

  @Mutation
  private SET_TOKEN (token: string) {
    this.token = token
  }

  @Mutation
  private SET_USERINFO (userInfo) {
    this.userInfo = userInfo
    setUserInfo(userInfo)
  }

  @Mutation
  private SET_NAME (name: string) {
    this.name = name
  }

  @Mutation
  private SET_AVATAR (avatar: string) {
    this.avatar = avatar
  }

  @Mutation
  private SET_INTRODUCTION (introduction: string) {
    this.introduction = introduction
  }

  @Mutation
  private SET_ROLES (roles: string[]) {
    this.roles = roles
  }

  @Mutation
  private SET_MENULIST (menuList: object[]) {
    this.menuList = menuList
  }

  @Mutation
  private SET_TABDTOLIST (tabDtoList: TabItem[]) {
    this.tabDtoList = tabDtoList
  }

  @Mutation
  private SET_ORGTREE (orgTree: object[]) {
    this.orgTree = orgTree
  }

  @Mutation
  private SET_ACCESSLIST (accessList: string[]) {
    this.accessList = accessList
  }

  @Mutation
  private SET_EMAIL (email: string) {
    this.email = email
  }

  @Action
  public async Login (userInfo: { loginType:number, agentId: string, agentAuth: string, required: boolean, imgValidCodeId: string, imgValidCodeText: string }) {
    let { loginType, agentId, agentAuth, imgValidCodeId, imgValidCodeText } = userInfo
    agentId = agentId.trim()
    if (loginType === 0) {
      agentAuth = Md5.hashStr(agentAuth)
    }
    const { data, code } = await login({ loginType, agentId, agentAuth, imgValidCodeId, imgValidCodeText })
    if (code === 0) {
      setToken(data.token)
      this.SET_TOKEN(data.token)
      this.SET_USERINFO(data)
    // this.GetOrgTree()
    }
  }

  @Action
  public async GetOrgTree () {
    const { data } = await sysOrgTree({ id: 1 })
    this.SET_ORGTREE([data])
    setOrgTree(data)
  }

  @Action
  public ResetToken () {
    removeToken()
    this.SET_TOKEN('')
    this.SET_ROLES([])
    this.SET_ACCESSLIST([])
    this.SET_USERINFO({})
  }

  @Action
  public async GetUserInfo () {
    if (this.token === '') {
      throw Error('GetUserInfo: token is undefined!')
    }
    // const { data } = await getUserInfo()
    // if (!data) {
    //   throw Error('Verification failed, please Login again.')
    // }
    // const { menuList, permissions, tabDtoList } = data
    // if (!menuList) {
    //   Message({
    //     message: '该用户未授权菜单，请联系管理员',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    // }

    // this.SET_ACCESSLIST(permissions)
    // this.SET_MENULIST(menuList)
    this.SET_TABDTOLIST(tabDtoList)
    this.SET_ROLES(['ADMIN'])
  }

  @Action
  public async ChangeRoles () {
    Message({
      message: '切换应用中',
      type: 'warning',
      duration: 1 * 1000
    })
    await this.GetUserInfo()
    const accessRoutes:any = await PermissionModule.GenerateRoutes(this.menuList)
    resetRouter()
    accessRoutes.forEach((currentRouter:any) => {
      router.addRoute(currentRouter)
    })
    // router.addRoutes(accessRoutes) // 动态添加可访问路由表

    // PermissionModule.dynamicRoutes.forEach(route => {
    //   router.addRoute(route)
    // })
    // Reset visited views and cached views
    TagsViewModule.delAllViews()
  }

  @Action
  public async LogOut () {
    if (this.token === '') {
      throw Error('LogOut: token is undefined!')
    }
    try {
      await logout()
    } catch (error) {

    }
    // await logout()
    removeToken()
    resetRouter()

    TagsViewModule.delAllViews()
    this.SET_TOKEN('')
    this.SET_ROLES([])
    this.SET_USERINFO({})
  }
}

export const UserModule = getModule(User)
